import { MessagingConsumer } from './messaging';

export const withMessaging = Component => props =>
  <MessagingConsumer>{context => <Component {...props} {...context} />}</MessagingConsumer>;
